import React, { useMemo, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import SearchIcon from '@mui/icons-material/Search';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ListIcon from '@mui/icons-material/List';
import BarChartIcon from '@mui/icons-material/BarChart';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import StarBorder from '@mui/icons-material/StarBorder';
import BallotIcon from '@mui/icons-material/Ballot';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'; // outline heart icon
import Collapse from '@mui/material/Collapse';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import HomeWork from '@mui/icons-material/HomeWork';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import HouseIcon from '@mui/icons-material/House';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DirectionsIcon from '@mui/icons-material/Directions';
import ListLink from './ListLink';
import ListButton from './ListButton';
import { useUserState } from '../../../hook/customerHook';
import { logout, getAllPermissionForUser } from '../../../api/serverRequests';
import { ListSubheader } from '@mui/material';
import WebIcon from '@mui/icons-material/Web';
import SchoolIcon from '@mui/icons-material/School';
import DescriptionIcon from '@mui/icons-material/Description';
import CampaignIcon from '@mui/icons-material/Campaign';

export default function NavList() {
	let page = window.location.href.includes('/user/')
		? window.location.href.split('/user/')[1]
		: window.location.href.split('/').pop();
	const history = useHistory();
	const [open, setOpen] = React.useState(page === 'tagsetting' || page === 'organizationstatus');
	const [openMain, setOpenMain] = React.useState(
		page === 'search' ||
			page === 'search-active' ||
			page === 'search-foreclosure' ||
			page === 'search-priced-dropped'
	);
	const [userState, dispatchUser] = useUserState();
	const [perms, setPerms] = React.useState([]);

	React.useEffect(() => {
		const fetchPermissions = async () => {
			if (!userState.permission) {
				try {
					const res = await getAllPermissionForUser(userState.user.user_id);
					if (res.data.success) {
						const fetchedPerms = res.data.permissions.map((p) => p.PermissionId);
						setPerms(fetchedPerms);
						dispatchUser({ permission: fetchedPerms });
					}
				} catch (err) {
					console.error(err.message);
				}
			} else {
				setPerms(userState.permission);
			}
		};

		fetchPermissions();
	}, []);

	const VIEW_FORECLOSURE_PERM_ID = 11;
	const VIEW_DEAL_PERM_ID = 12;
	const SETTING_ACCESS_PERM_ID = 21;
	const VIEW_OFFMARKET_SEARCH_PERM_ID = 25;
	const VIEW_PLAN_ROUTES_PERM_ID = 17;
	const VIEW_EDIT_HISTORY_PERM_ID = 19;
	const SCHEDULE_UPDATE_PERM_ID = 97;

	const handleClickSettings = () => {
		setOpen(!open);
	};

	const handleMainClickSettings = () => {
		setOpenMain(!openMain);
	};

	const handleLogout = () => {
		/* 		dispatchUser({
			isLoggedIn: false,
			propertyClusters: null,
			propertyUrl: null,
			activeFilters: null,
			priceListingFilters: null,
			filters: null,
			advFilters: null,
			checkedLetterhead: false,
			checkedUsername: false,
			routingList: null,
			currentRouteId: null,
			selectedRoutes: null,
			selectedRoutesCheckbox: null
		}); */

		const item = userState;

		for (const key of Object.keys(item)) {
			if ('isLoggedIn' === key || 'checkedLetterhead' === key || 'checkedUsername' === key) {
				userState[key] = false;
			} else userState[key] = null;
		}
		userState['advFilters'] = null;
		userState['mapFilter'] = null;
		userState['userFilters'] = null;
		dispatchUser(item);

		localStorage.clear();

		logout().then((res) => history.push('/login'));
	};

	const mainItems = [
		{
			link: '/user/search',
			label: 'Search',
			page: 'search',
			iconComponent: FindInPageIcon,
			isActive: true,
			isAuth: true,
			isRole: VIEW_OFFMARKET_SEARCH_PERM_ID
		},
		{
			link: '/user/dashboard',
			label: 'Dashboard',
			page: 'dashboard',
			iconComponent: DashboardIcon,
			isActive: true
		},
		{
			link: '/user/task',
			label: 'Task Board',
			page: 'task',
			iconComponent: AssignmentIcon,
			isActive: true
		},
		{
			link: '/user/follow-ups',
			label: 'Follow Ups',
			page: 'follow-ups',
			iconComponent: EventNoteIcon,
			isActive: true
		},
		{
			link: '/user/routes',
			label: 'Routes',
			page: 'routes',
			iconComponent: DirectionsIcon,
			isActive: true,
			isRole: VIEW_PLAN_ROUTES_PERM_ID
		},
		{
			link: '/user/collection',
			label: 'Favorites',
			page: 'collection',
			iconComponent: FavoriteBorderIcon,
			isActive: true
		},
		{
			link: '/user/organization',
			label: 'Organization',
			page: 'organization',
			iconComponent: BusinessIcon,
			isActive: true
		},
		{
			link: '/command-centre',
			label: 'Command Centre',
			page: 'command-centre',
			iconComponent: WebIcon,
			isActive: true
		},
		{
			link: '/campaigns',
			label: 'Campaigns',
			page: 'campaigns',
			iconComponent: CampaignIcon,
			isActive: true,
			isAuth: true
		},
		{
			link: '/learn',
			label: 'Learn',
			page: 'learn',
			iconComponent: SchoolIcon,
			isActive: true,
			isAuth: true
		},
		{
			link: '/flyer',
			label: 'Flyer',
			page: 'flyer',
			iconComponent: DescriptionIcon,
			isActive: false,
			isAuth: true
		},
		/*{
			link: '/letter-designer',
			label: 'Letter Designer',
			page: 'letter-designer',
			iconComponent: DescriptionIcon,
			isActive: true,
			isAuth: true
		},*/
		{
			link: null,
			label: 'Report',
			page: 'report',
			iconComponent: BarChartIcon,
			isActive: false
		},
		{
			link: null, // link: '/user/tour'
			label: 'Tour',
			page: 'tour',
			iconComponent: AddLocationIcon,
			isActive: false
		}
	];

	const activeListings = [
		{
			link: '/user/search-active',
			label: 'Undervalued',
			page: 'search-active',
			iconComponent: WhatshotIcon,
			isActive: true,
			isAuth: true,
			isRole: VIEW_DEAL_PERM_ID
		}
		// {
		// 	link: '/user/search-foreclosure',
		// 	label: 'Foreclosure',
		// 	page: 'search-foreclosure',
		// 	iconComponent: AccountBalanceIcon,
		// 	isActive: true,
		// 	isAuth: true,
		// 	isRole: VIEW_FORECLOSURE_PERM_ID
		// }
	];
	const secondaryItems = [
		{
			link: '/user/settings',
			label: 'Settings',
			page: 'settings',
			iconComponent: AccountBoxIcon,
			isActive: true,
			isAuth: true,
			isRole: SETTING_ACCESS_PERM_ID
		},
		{
			link: '/user/audit',
			label: 'Audit',
			page: 'audit',
			iconComponent: LibraryAddCheckIcon,
			isActive: true,
			isAuth: true,
			isRole: VIEW_EDIT_HISTORY_PERM_ID
		}
	];

	const logoutItem = {
		link: null,
		label: 'Logout',
		page: null,
		iconComponent: ExitToAppIcon,
		isActive: true,
		hasSubItems: false,
		handleClick: handleLogout
	};

	const subItems = [
		{
			link: '/user/tagsetting',
			label: 'Tags',
			page: 'tagsetting',
			iconComponent: StarBorder,
			isActive: true,
			isAuth: true
		},
		{
			link: '/user/organizationstatus',
			label: 'Status',
			page: 'organizationstatus',
			iconComponent: BallotIcon,
			isActive: true,
			isAuth: true
		}
	];

	const subListItems = useMemo(
		() => (
			<Collapse in={open} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					{subItems.map(
						(item, idx) =>
							item.isAuth &&
							item.isActive && (
								<ListLink key={idx} navItem={item} selected={page === item.page} />
							)
					)}
				</List>
			</Collapse>
		),
		[page, open]
	);

	const filteredMainItems = mainItems.filter((item) => {
		if (!item.isRole) {
			return true;
		}

		return perms.includes(item.isRole);
	});

	const mainListItems = useMemo(
		() =>
			filteredMainItems.map(
				(item, idx) =>
					item.isActive && (
						<ListLink key={idx} navItem={item} selected={page === item.page} />
					)
			),
		[page, perms]
	);

	const filteredActiveListingsItems = activeListings.filter((item) => {
		if (!item.isRole) {
			return true;
		}

		return perms.includes(item.isRole);
	});

	const activeListingsItems = useMemo(
		() =>
			filteredActiveListingsItems.map(
				(item, idx) =>
					item.isActive && (
						<ListLink key={idx} navItem={item} selected={page === item.page} />
					)
			),
		[page, perms]
	);

	const secondaryListItems = useMemo(
		() =>
			secondaryItems.map((item, idx) => {
				return item.isAuth == null || (item.isAuth && perms.includes(item.isRole)) ? (
					item.link ? (
						<ListLink key={idx} navItem={item} selected={page === item.page} />
					) : (
						<Fragment key={idx}>
							<ListButton
								navItem={item}
								handleClick={item.handleClick}
								isExpanded={open}
							/>
							{item.hasSubItems && subListItems}
						</Fragment>
					)
				) : (
					<></>
				);
			}),
		[page, open, perms]
	);

	const renderLogoutItem = (item) => {
		return (
			<Fragment>
				<ListButton navItem={item} handleClick={item.handleClick} isExpanded={open} />
				{item.hasSubItems && subListItems}
			</Fragment>
		);
	};
	return (
		<>
			<Divider />
			<List>{mainListItems}</List>
			<Divider />
			<List>{activeListingsItems}</List>
			<Divider />
			<List>{secondaryListItems}</List>
			<Divider />
			{renderLogoutItem(logoutItem)}
		</>
	);
}
